import { MonitoringLegacyService } from '../../../../../../services/module'

class LegacyDecorator {
  path = '/monitoring-legacy'

  showLog (id, date, jobIdentifier, processType) {
    const query = { processType, date, jobIdentifier, id }
    const params = new URLSearchParams(query)
    const route = `${origin}/monitoring-legacy/process-log?${params}`
    open(route)
  }

  showLastLogs (integrationName, processType) {
    MonitoringLegacyService.findAllDates(processType, integrationName)
      .then(({ data }) => {
        const lastDate = data?.sort?.().pop()
        const query = {
          processType,
          jobIdentifier: integrationName,
          date: lastDate
        }

        const params = new URLSearchParams(query)
        const route = `${origin}/monitoring-legacy?${params}`

        open(route)
      })
  }
}

export default new LegacyDecorator()
